const getAuthHeaders = () => ({
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json'
});

/**
 * 依 stepExecutionId 取得 sessions（供 WorkflowMonitor Modal 使用）。
 */
export const fetchByStepExecution = async (stepExecutionId) => {
  const response = await fetch(
    `/api/chatbot-sessions/by-step-execution/${stepExecutionId}`,
    { headers: getAuthHeaders() }
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

/**
 * 取得全域 Inbox session 列表。
 * @param {{ page?, pageSize?, source?, contactType?, search? }} params
 */
export const fetchInbox = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set('page', params.page);
  if (params.pageSize) query.set('pageSize', params.pageSize);
  if (params.source && params.source !== 'all') query.set('source', params.source);
  if (params.contactType && params.contactType !== 'all') query.set('contactType', params.contactType);
  if (params.search) query.set('search', params.search);
  const qs = query.toString();
  const response = await fetch(
    `/api/chatbot-sessions/inbox${qs ? `?${qs}` : ''}`,
    { headers: getAuthHeaders() }
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

/**
 * 輕量 Inbox 輪詢：只回傳 session metadata（不含 messages 陣列）。
 * since 為 ISO 字串，只取該時間點之後更新的 sessions。
 * @param {{ source?, contactType?, search?, since? }} params
 */
export const fetchInboxMeta = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.source && params.source !== 'all') query.set('source', params.source);
  if (params.contactType && params.contactType !== 'all') query.set('contactType', params.contactType);
  if (params.search) query.set('search', params.search);
  if (params.since) query.set('since', params.since);
  const qs = query.toString();
  const response = await fetch(
    `/api/chatbot-sessions/inbox-meta${qs ? `?${qs}` : ''}`,
    { headers: getAuthHeaders() }
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

/**
 * Admin 介入發送 WhatsApp 訊息（不寫入 ChatBot 歷史）。
 */
export const sendIntervention = async ({ waId, message, workflowInstanceId }) => {
  const response = await fetch('/api/whatsapp/send-message', {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ waId, message, workflowInstanceId })
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};
